import { Injectable } from '@angular/core';
import { AuthRolService } from '../../../../core/services/auth-rol.service';

@Injectable({
  providedIn: 'root',
})
export class PalletViewDataDisplayAuthService extends AuthRolService {
  beingAbleToScan(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }
}
